import { PayStatus } from "@/models/etc/types";

// dd.MM.yy (UTC); пустая строка, если значение отсутствует/некорректно
export const formatShortDate = (value: Date | string | undefined | null): string => {
	if (!value) {
		return ''
	}
	const d = new Date(value)
	if (Number.isNaN(d.getTime())) {
		return ''
	}
	const day = String(d.getUTCDate()).padStart(2, '0')
	const month = String(d.getUTCMonth() + 1).padStart(2, '0')
	const year = String(d.getUTCFullYear()).slice(-2)
	return `${day}.${month}.${year}`
}

export const payStatusText = (status: PayStatus | number | undefined): string => {
	switch (status) {
		case PayStatus.Cancelled: return 'Отменён'
		case PayStatus.NotPayed: return 'Не оплачен'
		case PayStatus.PartlyPayed: return 'Частично оплачен'
		case PayStatus.Payed: return 'Оплачен'
		default: return 'Неизвестно'
	}
}

// ширина заливки прогресс-бара, 0..100 %
export const barWidth = (percent: number | undefined | null): string => {
	const p = Math.max(0, Math.min(100, percent ?? 0))
	return `${p}%`
}

export const formatMoney = (value: number | undefined | null): string =>
	(value ?? 0).toLocaleString('ru-RU')
